module.exports = __webpack_public_path__ + "static/media/intro.27508229.PNG";